export const WHATSAPP_NUMBER = "+527223818617";
export const WHATSAPP_MESSAGE = "Hola, necesito recuperar mi sitio WordPress. Vengo desde la landing.";
export const WHATSAPP_LINK = `https://wa.me/527223818617?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;